import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Icon,
  Button,
  Dropdown,
  Menu,
  Modal,
  Input,
  InputNumber,
  message,
} from 'antd'
import _ from 'lodash'
import custom from '../../config/custom'
import { request } from '../../utils/http'
import { updateDispatchById } from '../../modules/dispatch'
import moment from 'moment'

const confirm = Modal.confirm
const { TextArea } = Input

class DispatchControl extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cancelComment: '',
      canceling: false,
      closing: false,
      sendingReceivedEmail: false,
      sendingApprovedEmail: false,
      starting: false,
      finishing: false,
      amount: 0,
      deletingItems: false,
      stamping: false,
    }
  }

  getValue(inputs){
    const { values, keyString, emptyValue } = inputs;
    const keys = keyString.split(".");
    let value = values;
    _.each(keys, (k) => {
      if (value && value[k]) {
        value = value[k];

        if (Array.isArray(value)) {
          if (typeof keys[keys.length - 1] === "number") {
            value = _.sumBy(value, keys[keys.length - 1]);
            if (value < 0) value = 0;
          } else {
            value = value[0];
          }
        }
      }

      if (["string", "number"].includes(typeof value)) return false;
    });

    if (value instanceof Date) return value;

    return ["string", "number"].includes(typeof value)
      ? String(value).replace(/,/g, "")
      : emptyValue;
  };

  validateDispatch (dispatch) {
    const { customer } = dispatch;
    const required = [
      {
        origin: dispatch,
        properties: [
          {
            value: "id",
            description: "Identificador del tránsito",
          },
          {
            value: "exchangeRate",
            description: "Tipo de Cambio",
          },
          {
            value: "type.name",
            description: "Nombre del movimiento",
          },
          {
            value: "type.sapId",
            description: "Clave SAP del movimiento",
          },
          {
            value: "serviceType.id",
            description: "Identificador del tipo de servicio",
          },
          {
            value: "pickupCommitmentTime",
            description: "Fecha compromiso de recolección",
          },
          {
            value: "deliveryCommitmentTime",
            description: "Fecha compromiso de entrega",
          },
          {
            value: "items.weight",
            description: "Peso de la mercancia",
          },
          {
            value: "vehicle.insurancePolicy",
            description: "Poliza de seguro de la unidad",
          },
          {
            value: "vehicle.plateMx",
            description: "Placa mexicana de la unidad",
          },
          {
            value: "vehicletype.vehicleConfiguration",
            description: "Clave correspondiente al SAT en el tipo de unidad",
          },
          {
            value: "driver.rfc",
            description: "RFC del conductor",
          },
          {
            value: "driver.license",
            description: "Licensia del conductor",
          },
        ],
      },
      {
        origin: customer,
        properties: [
          { value: "sapId", description: "Clave SAP asociada al cliente" },
          { value: "rfc", description: "RFC asociado al cliente" },
          { value: "name", description: "Nombre del cliente" },
          { value: "address", description: "Domicilio del cliente" },
          // { value: "neighborhood", description: "Vecindario del cliente" },
          {
            value: "zipCode",
            description: "Codigo Postal del domicilio del cliente",
          },
          { value: "city", description: "Ciudad donde radica el cliente" },
          { value: "state", description: "Estado donde radica el cliente" },
        ],
      },
    ];

    let response = [];

    const properties = required
      .map((item) =>
        item.properties.map((property) => {
          const value = this.getValue({
            values: item.origin,
            keyString: property.value,
            emptyValue: null,
          });

          response.push({
            ...property,
            recollected: value,
          });
          return value;
        })
      )
      .flat();

    return {
      properties: response,
      isValid: !properties.includes(null),
    };
  }

  hasPermission(value) {
    const permissions = _.first(this.props.user.profile).role.permissions
    for (let i in permissions) {
      if (permissions[i].name === value) {
        return true
      }
    }
    return false
  }

  showMap(origin, destination) {
    window.open(`https://maps.google.com?saddr=${encodeURIComponent(origin.address)}&daddr=${encodeURIComponent(destination.address)}&dirflg=d`)
  }

  showFiles(id, sapId) {
    const startPadding = id > 850 ? 5 : 6
    window.open(`https://files.g-global.com.mx/files#!/${sapId}/transporte/TMS-${_.padStart(id, startPadding, 0)}/`)
  }

  showCartaPorte(id) {
    window.open(`${custom.baseUrl}/dispatch/${id}/pdf`)
  }

  sendCartaPorteByEmail(id) {
    request(`${custom.baseUrl}/dispatch/${id}/pdf`, {
      params: {
        sendEmail: true
      }
    })
  }

  receiveDispatch() {
    this.setState({
      sendingReceivedEmail: true
    })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/received`)
      .then(response => {
        message.success('Solicitud recibida')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo marcar como recibida')
      })
      .then(() => {
        this.setState({
          sendingReceivedEmail: false
        })
      })
  }

  approveDispatch() {
    this.setState({
      sendingApprovedEmail: true
    })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/approved`)
      .then(response => {
        message.success('Solicitud aprobada')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo aprobar el tránsito')
      })
      .then(() => {
        this.setState({
          sendingApprovedEmail: false
        })
      })
  }

  approvePreDispatch() {
    this.setState({
      sendingApprovedEmail: true
    })

    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/received`)
      .then(response => {
        message.success('Pre-Solicitud aprobada')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo aprobar el pre-tránsito')
      })
      .then(() => {
        this.setState({
          sendingApprovedEmail: false
        })
      })
  }

  startDispatch() {
    this.setState({ starting: true })
    request(`${custom.baseUrl}/dispatch/${this.props.id}/status/started`)
      .then(response => {
        message.success('Tránsito iniciado')
        this.props.updateDispatchById(this.props.id)
      })
      .catch(() => {
        message.warning('No se pudo iniciar el tránsito')
      })
      .then(() => {
        this.setState({ starting: false })
      })
  }

  addToCart(supplier) {
    this.setState({ amount: 0 })
    return new Promise((resolve, reject) => {
      confirm({
        title: `Pago a ${supplier.name}`,
        content: (
          <div>
            <InputNumber
              defaultValue={0}
              onChange={value => { this.setState({ amount: value }) }}
              min={0}
              style={{ width: '100%' }}
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/\$\s?|(,*)/g, '')}
            />
          </div>
        ),
        okText: 'Confirmar',
        cancelText: 'Cerrar',
        centered: true,
        onOk: () => {
          if (this.state.amount > 0) {
            setTimeout(() => {
              resolve()
            }, 200)
          } else {
            message.warning('El importe debe ser mayor a cero')
            return 'Error'
          }
        },
        onCancel: () => {
          this.setState({ amount: 0 }, () => {
            reject()
          })
        },
      })
    })
  }

  async finishDispatch() {
    const dispatch = _.find(this.props.items, dispatch => dispatch.id === this.props.id)
    if (dispatch.billType &&
      dispatch.supplier &&
      dispatch.supplier.name !== 'G-TRANSPORT') {
      try {
        await this.addToCart(dispatch.supplier)
      } catch (error) {
        return
      }
    }
    confirm({
      title: 'Finalizar tránsito?',
      content: 'Una vez finalizado únicamente administradores podrán editar la información del tránsito',
      okText: 'Sí',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ finishing: true })
        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/finished`, {
          params: {
            amount: this.state.amount
          }
        })
          .then(response => {
            message.success('Tránsito finalizado')
            this.props.updateDispatchById(this.props.id)
          })
          .catch(() => {
            message.warning('No se pudo finalizar el tránsito')
          })
          .then(() => {
            this.setState({ finishing: false })
          })
      },
      onCancel: () => {
        this.setState({ finishing: false })
      },
    });
  }

  cancelDispatch() {
    confirm({
      title: 'Cancelar tránsito?',
      content: <TextArea placeholder={'Comentario requerido'} onChange={event => { this.setState({ cancelComment: event.target.value }) }} />,
      okText: 'Confirmar',
      okType: 'danger',
      cancelText: 'Cerrar',
      maskClosable: true,
      onOk: () => {
        if (!this.state.cancelComment) {
          return true
        }

        this.setState({ canceling: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/canceled`, {
          params: {
            comment: this.state.cancelComment
          }
        })
          .then(response => {
            message.success('Tránsito cancelado')

            this.props.updateDispatchById(this.props.id)
          })
          .catch(() => {
            message.warning('No se pudo cancelar el tránsito')
          })
          .then(() => {
            this.setState({ canceling: false })
          })
      },
      onCancel: () => {

      },
    })
  }

  downloadStamp(stampId) {
    window.open(`${custom.baseUrl}/stampfile/${stampId}/download`);
  }

  timbrado(record) {
    this.setState({ stamping: true })

    request(`${custom.baseUrl}/dispatch/${record.id}/stamp`)
    .then((response) => {
      if (!response.data.error){
        message.success('Tránsito timbrado');
        this.downloadStamp(response.data.stamp.id);
        this.props.updateDispatchById(record.id)
      } else {
        const apiMessage = _.get(response, 'data.message', 'SAP no ha proporcionado un mensaje de error');
        message.warning('No se pudo generar el complemento carta porte', 10);
        message.warning(apiMessage, 20);
      }
    })
    .catch(() => {
      message.warning('No se pudo cerrar el tránsito')
    })
    .then(() => {
      this.setState({ stamping: false })
    })
  }

  closeDispatch() {
    confirm({
      title: 'Cerrar tránsito?',
      content: 'Una vez cerrado no se podrá editar la información del tránsito',
      okText: 'Sí',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ closing: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/status/closed`)
          .then(response => {
            message.success('Tránsito cerrado');
            this.props.updateDispatchById(this.props.id)
          })
          .catch(() => {
            message.warning('No se pudo cerrar el tránsito')
          })
          .then(() => {
            this.setState({ closing: false })
          })
      },
      onCancel: () => {

      },
    })
  }

  deleteItems() {
    confirm({
      title: '¿Eliminar mercancias?',
      content: 'Una vez eliminadas no se podrán recuperar',
      okText: 'Sí',
      okType: 'danger',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ deletingItems: true })

        request(`${custom.baseUrl}/dispatch/${this.props.id}/items-delete`, { method: 'post' })
          .then((response) => {
            message.success('Mercancias eliminadas')
          })
          .catch(() => {
            message.warning('No se pudieron eliminar mercancias')
          })
          .then(() => {
            this.setState({ deletingItems: false })
          })
      },
      onCancel: () => {

      },
    })
  }

  validateDispatchMovement(record) {
    const movements = ['LOCAL INTERNACIONAL', 'LOCAL DOMÉSTICO'];

    return !!movements.find((movement) => record.type.name.includes(movement));
  }

  transmitirExtraCargos(dispatchId, charges) {
    const newReference = `TMS-${(dispatchId).toString().padStart(5, "0")}-${moment().format('YYMMDDHHmmss')}`;
    confirm({
      title: `¿Transmitir ${charges.length} extra cargos?`,
      content: `Nuevo folio que se comunicará a SAP: ${newReference}`,
      okText: 'Sí',
      okType: 'success',
      cancelText: 'No',
      maskClosable: true,
      centered: true,
      onOk: () => {
        this.setState({ stamping: true })

        request(`${custom.baseUrl}/dispatch/${dispatchId}/transmit`, { method: 'post', data: { newReference } })
          .then((response) => {
            message.success(response.data.message)
          })
          .catch(() => {
            message.warning('No ha sido posible transmitir el tránsito')
          })
          .finally(() => {
            this.setState({ stamping: false })
          })
      },
      onCancel: () => {},
    })
  }

  render() {
    const record = _.find(this.props.items, { id: this.props.id })

    if (!record) {
      return null
    }

    const charges = record.charges || [];

    let chargesUntransmitted = charges.filter((charge) => !charge.transmitted);

    const canEdit = this.hasPermission('Editar')

    const menu = (
      <Menu onClick={(event) => {
        switch (event.key) {
          case 'ruta':
            this.showMap(record.origin, record.destination)
            break;
          case 'archivos':
            this.showFiles(record.id, record.customer.sapId)
            break;
          case 'carta':
            this.showCartaPorte(record.id)
            break;
          case 'send-carta':
            this.sendCartaPorteByEmail(record.id)
            break;
          case 'recibir':
            if (!canEdit) break;
            this.receiveDispatch()
            break;
          case 'aprobar':
            if (!canEdit) break;
            this.approveDispatch()
            break;

          case 'aprobar-pre':
            if (!canEdit) break;
            this.approvePreDispatch()
            break;
          case 'iniciar':
            if (!canEdit) break;
            this.startDispatch()
            break;
          case 'finalizar':
            if (!canEdit) break;
            this.finishDispatch()
            break;
          case 'cerrar':
            if (!canEdit) break;
            this.closeDispatch()
            break;
          case 'cancelar':
            if (!canEdit) break;
            this.cancelDispatch()
            break;
          case 'downloadStamp':
            this.downloadStamp(record.stamp);
            break;
          case 'eliminar-mercancias':
            this.deleteItems();
            break;
          case 'timbrado':
            this.timbrado(record)
            break;
          case 'transmitirExtraCargos':
            this.transmitirExtraCargos(record.id, chargesUntransmitted);
            break;
          default:
            break;
        }
      }}>
        <Menu.Item key="ruta">
          <Icon type="compass" />
          Mostrar ruta
        </Menu.Item>
        {
          record.customer && record.files && record.files.length > 0 &&
          Boolean(record.files.length) &&
          <Menu.Item key="archivos">
            <Icon type="paper-clip" />
            Mostrar documentos
        </Menu.Item>
        }
        <Menu.Item key="carta">
          <Icon type="file-text" />
          Generar Carta Porte
        </Menu.Item>
        <Menu.Item key="send-carta">
          <Icon type="file-text" />
          Enviar Carta Porte
        </Menu.Item>
        {
          !record.receivedAt &&
          !record.requestedAt &&
          <Menu.Item key="recibir" disabled={!canEdit || this.state.sendingReceivedEmail}>
            <Icon type="mail" />
            Marcar como recibido
        </Menu.Item>
        }
        {
          record.requestedAt &&
          !record.receivedAt &&
          <Menu.Item key="aprobar-pre" disabled={!canEdit || this.state.sendingApprovedEmail}>
            <Icon type="mail" />
            Aprobar pre-solicitud
          </Menu.Item>
        }
        {
          record.receivedAt &&
          !record.approvedAt &&
          <Menu.Item key="aprobar" disabled={!canEdit || this.state.sendingApprovedEmail}>
            <Icon type="mail" />
            Aprobar solicitud
          </Menu.Item>
        }
        {
          record.approvedAt &&
          !record.startedAt &&
          <Menu.Item key="iniciar" disabled={!canEdit || this.state.starting}>
            <Icon type="play-circle" />
            Iniciar Viaje
          </Menu.Item>
        }
        {
          record.startedAt &&
          !record.finishedAt &&
          !record.canceledAt &&
          <Menu.Item key="finalizar" disabled={!canEdit || this.state.finishing}>
            <Icon type="check-circle" />
            Finalizar viaje
          </Menu.Item>
        }
        {
          this.hasPermission('Cerrar') &&
          record.finishedAt &&
          !record.closedAt &&
          <Menu.Item key="cerrar" disabled={!canEdit || this.state.closing}>
            <Icon type="lock" />
            {this.state.closing ? 'Cerrando...' : 'Cerrar tránsito'}
          </Menu.Item>
        }
        {
          !record.canceledAt &&
          <Menu.Item key="cancelar" disabled={!canEdit || this.state.canceling}>
            <Icon type="delete" />
            {this.state.canceling ? 'Cancelando...' : 'Cancelar tránsito'}
          </Menu.Item>
        }
        {
          !record.stamp &&
          record.items &&
          record.items.length &&
          record.approvedAt &&
          <Menu.Item key="timbrado" disabled={this.state.stamping}>
            <Icon type="file-markdown" />
            {this.state.stamping ? 'Timbrando...' : 'Timbrar tránsito'}
          </Menu.Item>
        }
        {
          record.stamp &&
          <Menu.Item key="downloadStamp">
            <Icon type="download" />
            Descargar Timbrado
          </Menu.Item>
        }
        {
          record.stamp &&
          chargesUntransmitted.length > 0 &&
          <Menu.Item key="transmitirExtraCargos" disabled={this.state.stamping}>
            <Icon type="tags" />
            {this.state.stamping ? 'Transmitiendo...' : 'Transmitir Extra Cargos Pendientes a SAP'}
          </Menu.Item>
        }
        {
          record.items && record.items.length &&
          <Menu.Item key="eliminar-mercancias" disabled={!canEdit || this.state.canceling}>
            <Icon type="delete" />
            {this.state.deletingItems ? 'Eliminando...' : 'Eliminar mercancias'}
          </Menu.Item>
        }
      </Menu>
    );

    return (
      <div style={{ textAlign: 'center' }} onClick={(event) => event.stopPropagation()}>
        <Dropdown overlay={menu}>
          <Button shape="circle" icon="more" />
        </Dropdown>
      </div>
    )
  }

}

const mapStateToProps = state => ({
  user: state.auth.user,
  items: state.dispatch.items,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  updateDispatchById,
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(DispatchControl)



// WEBPACK FOOTER //
// ./src/containers/DispatchControl/index.js